<template>
  <div>
    <div class="rj-col-3">
      <div class="rj-baseinfo">
        <div class="rj-baseinfo__label">
          订单类型<span v-if="required" class="required">*</span>：
        </div>
        <div class="rj-baseinfo__item">
          <el-form-item prop="saleTypeCode">
            <el-select ref="saleType" v-model="form.saleTypeCode" placeholder="请选择订单类型" style="width:100%;" @change="change">
              <el-option v-for="option in contratOrderType" :key="option.code" :value="option.code" :label="option.name " />
            </el-select>
          </el-form-item>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="es6">
import { getOrderTypesBySupplyUnit } from '@/API';
export default {
  data () {
    return {
      OrderType: '',
      contratOrderType: []
    };
  },
  model: {
    prop: 'form',
    event: 'change'
  },
  props: {
    form: {
      type: Object,
      default: () => { return {}; }
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  computed: {
  },
  methods: {
    changeTaxType (val) {
      this.getContratOrderType(val.supplyUnitId, val.currencyId, true);
    },
    initContratOrderType () {
      this.getContratOrderType(this.form.supplyUnitId, this.form.currencyId, false);
    },
    getContratOrderType (supplyUnitID, currencyId, isChange) {
      if (supplyUnitID && currencyId) {
        getOrderTypesBySupplyUnit(supplyUnitID, currencyId).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            let list = [];
            json.data.forEach((item) => {
              let map = {
                code: item.basicInfoID,
                name: item.basicInfoName
              };
              list.push(map);
            });
            this.contratOrderType = list;
            if (isChange) {
              this.form.saleTypeCode = '';
            }
          }
        }).catch(() => {
        });
      } else {
        this.form.saleTypeCode = '';
      }
    },
    initData () {
      if (this.form.OrderType) {
        // this.OrderType = this.form.supplyAddress;
      }
    },
    change (val) {
      this.$nextTick(() => {
        this.form.saleTypeName = this.$refs.saleType.selectedLabel;
      });
    }
  },
  mounted () {
    this.initContratOrderType();
    // this.initData();
  }
};
</script>
